export function address(state){
    return state.address
}

export function birthday(state){
    return state.birthday
}

export function email(state){
    return state.email
}

export function full_name(state){
    return state.full_name
}